"use strict";

exports.__esModule = true;
/* eslint-disable func-names */
var Plugins = function Plugins() {};
var p = Plugins.prototype;
p.push = function (plugin) {
  this[plugin.prototype.name] = plugin;
};
exports["default"] = new Plugins();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-tween-one/lib/plugins.js
// module id = 513
// module chunks = 55213770944713 173894859265406